<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-image: url(); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-12 col-md-10">
                        <h1 class="display-2 text-white">Hola {{usuario.firstName}}</h1>
                        <p class="text-white mt-0 mb-5">Estos son tus ajustes. Aquí puedes gestionar tus preferencias.</p>
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img :src="usuario.user_img" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">{{count_dietas}}</span>
                                            <span class="description">Dietas</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{count_rutinas}}</span>
                                            <span class="description">Rutinas</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{count_ejercicios}}</span>
                                            <span class="description">Ejercicios</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                    {{usuario.firstName}} {{usuario.lastName }}<span class="font-weight-light"></span>
                                </h3>
                                <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>{{usuario.city}}, {{usuario.country}}
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <base-alert class="alert-fixed" type="primary" v-if="notifications.success">
                        <strong>Datos actualizados con éxito!</strong>
                    </base-alert>
                    <base-alert class="alert-fixed" type="danger" v-if="notifications.failure">
                        <strong>Error, no se ha podido actualizar!</strong>
                    </base-alert>
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Ajustes</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <table>
                                <tr>
                                    <td><label for="esfuerzo">Usar esfuerzo </label></td>
                                    <td>
                                        <select class="form-control form-control-alternative" id="esfuerzo" v-model="usuario.use_esfuerzo">
                                            <option value="true">Activado</option>
                                            <option value="false">Desactivado</option>
                                        </select>
                                    </td>
                                   
                                </tr>
                                <tr>
                                    <td><label for="rpe">Usar RPE </label></td>
                                    <td>
                                        <select class="form-control form-control-alternative" id="rpe" v-model="usuario.use_rpe">
                                            <option value="true">Activado</option>
                                            <option value="false">Desactivado</option>
                                        </select>
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <button class="btn btn-primary btn-block" @click="onFormSubmit">Guardar</button>
                            <hr>
                            <h3>Esfuerzo</h3>
                            <p>
                                A la hora de emprender un plan de entrenamiento para la mejora de la capacidad cardiovascular o capacidad aeróbica, no es cuestión de salir a correr a cualquier ritmo
                            </p>
                            <p>
                                La forma de poder controlar las intensidades del ejercicio, es muy simple a través de la frecuencia cardíaca (FC).
                                Para más información; <a href="http://www.portalfitness.com/actividad_fisica/cardiovascular/porc_esfuerzo.htm">Aquí</a>.
                            </p>
                            <hr>
                            <h3>RPE</h3>
                            <p>
                                RPE es el acrónimo de Rating of Perceived Exertion, que en español se puede traducir como rango o índice de esfuerzo percibido. El RPE es un sistema de valoración de esfuerzo o intensidad ejercidas en un entrenamiento, sea cual sea la disciplina deportiva que practiquemos, tanto en deportes aeróbicos como anaeróbicos.
                            </p>
                            <p>
                                Para facilitar la correcta progresión del atleta y así evitar cualquier aparición de sobreentrenamiento o incluso posibles lesiones debido a una mala estructuración de su entrenamiento, contamos con una tabla de niveles RPE que van desde el nivel 1 hasta el nivel 10:
                            </p>
                            <table class="col table-responsive">
                                <tr><th>Nivel </th><th>Descripción</th><th>Pesas</th></tr>
                                <tr>
                                    <td>0</td>
                                    <td>Reposo</td>
                                    <td colspan="6">Desde el nivel 1 al 5, se puede considerar en el ámbito de la musculación como el esfuerzo realizado en un calentamiento o en las series de aproximación, hasta llegar a comenzar con las series efectivas</td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Muy  fácil</td>
                                    
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Fácil</td>
                                    
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Moderado</td>
                                    
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Algo Duro</td>
                                    
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Duro</td>
                                    
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Duro</td>
                                    <td>Se pueden realizar más repeticiones sin dificultad</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>Muy duro</td>
                                    <td>La última repetición es fácil, se pueden hacer 2 o 3 más</td>
                                </tr>
                                <tr>
                                    <td>8</td>
                                    <td>Muy duro</td>
                                    <td>Cerca de llegar al fallo muscular, se pueden hacer 1 o 2 más</td>
                                </tr>
                                <tr>
                                    <td>9</td>
                                    <td>Muy duro</td>
                                    <td>Casi llegando al fallo, incluso deteriorando técnica en la última</td>
                                </tr>
                                <tr>
                                    <td>10</td>
                                    <td>Máximo</td>
                                    <td>Levantamiento hasta el fallo, última repe muy lenta</td>
                                </tr>
                            </table>
                        </template>
                    </card>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { auth } from '../firebaseDb';
import { db } from '../firebaseDb';
  export default {
    name: 'user-profile',
    data() {
      return {
        user: auth.currentUser,
        usuario: {
          user_name: {
              type: String,
              default: 'username'
          },
          user_email: auth.currentUser.email,
          firstName: {
              type: String,
              default: 'Nombre'
          },
          lastName: {
              type: String,
              default: 'Apellidos'
          },
          address: {
              type: String,
              default: 'Dirección'
          },
          city: {
              type: String,
              default: 'Mi pueblo'
          },
          country: {
              type: String,
              default: 'País'
          },
          user_img:{
              type: String,
              default: "img/theme/team-4-800x800.jpg"
          },
          use_esfuerzo:{
              type: Boolean,
              default: false
          },
          use_rpe:{
              type: Boolean,
              default: false
          }
        },
        count_dietas: 0,
        count_ejercicios: 0,
        count_rutinas: 0,
        notifications: {
            success: false,
            failure: false
        },
        name_error: false,
        image_error: false,

      }
    },
    created: function() {
      //console.log(this.user)
      var self = this
      db.collection('users').doc(this.user.uid).get()
      .then(function(doc){
        if(doc.exists){          
          try{
            let user_name = doc.data().user_name
            self.usuario.user_name = user_name
            
            let firstName = doc.data().firstName
            self.usuario.firstName = firstName

            let lastName = doc.data().lastName
            self.usuario.lastName = lastName

            let user_email = doc.data().user_email
            self.usuario.user_email = user_email

            let city = doc.data().city
            self.usuario.city = city

            let country = doc.data().country
            self.usuario.country = country

            let esfuerzo = doc.data().use_esfuerzo
            self.usuario.use_esfuerzo = esfuerzo;


            let rpe = doc.data().use_rpe
            self.usuario.use_rpe = rpe;

            let user_avatar = doc.data().user_avatar
            if (user_avatar != "") {
                self.usuario.user_img = user_avatar
            }            
          }catch(error){
            console.log(error)
          }
        }
      });
        db.collection('users').doc(this.user.uid).collection('dietas').get()
            .then(snapshot => this.count_dietas = snapshot.size);
        db.collection('users').doc(this.user.uid).collection('rutinas').get()
            .then(snapshot => this.count_rutinas = snapshot.size);
        db.collection('ejercicios').get()
            .then(snapshot => this.count_ejercicios = snapshot.size);
    
    },
    methods: {
        async onFormSubmit(event) {
            event.preventDefault();
            let self = this;
                this.track_profile();
                db.collection('users').doc(this.user.uid)
                .update({
                    use_esfuerzo: this.usuario.use_esfuerzo,
                    use_rpe: this.usuario.use_rpe,

                }).then(() => {
                    this.name_error = false;
                    this.notifications.success = true;
                    setTimeout(function() {
                        self.notifications.success = false;
                    }, 3000);                        
                }).catch((error) => {
                    console.log(error);
                    this.notifications.failure = true; 
                    setTimeout(function() {
                        self.notifications.failure = false;
                    }, 3000);                    
                });
            
        },     
        track_profile() {
            this.$gtag.event("updated_profile", {
            'event_category': "profile",
            'event_label': "profile_updated",
            'value': 1
            })
        },
        track_avatar() {
            this.$gtag.event("updated_avatar", {
            'event_category': "profile",
            'event_label': "avatar_updated",
            'value': 1
            })
        },
            
    }
  };
</script>
<style>
img {
    max-width: 100%;
}
.alert-fixed {
    position:fixed; 
    top: 0px; 
    left: 0px; 
    width: 100%;
    z-index:9999; 
    border-radius:0px
}
</style>
